<div class="relative flex flex-col w-full h-full p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10 2xl:p-12 overflow-hidden bg-dashboard-bg">
  <div class="relative z-10 mb-3 sm:mb-4 md:mb-5 lg:mb-6 xl:mb-8 2xl:mb-10">
    <h2 class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white tracking-widest uppercase font-tech">
      Current Customers
    </h2>
  </div>

  <div class="relative z-10 flex-1 flex flex-col gap-1 sm:gap-1.5 md:gap-2 lg:gap-3 xl:gap-3 2xl:gap-4 overflow-hidden min-h-0" [@staggerSlideIn]="animationTrigger()">
    @for (client of clients(); track client.name) {
    <div class="bg-dashboard-panel px-3 sm:px-5 md:px-7 lg:px-10 xl:px-12 2xl:px-16 py-1 sm:py-1 md:py-1.5 lg:py-2 xl:py-2.5 2xl:py-3 flex-1 flex items-center justify-between rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-[2rem] shadow-xl">
      <div class="flex flex-col">
        <span class="text-dashboard-text font-black text-xs sm:text-sm md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-tight">
          {{ client.name }}
        </span>
        <span class="text-dashboard-text/60 font-medium text-[8px] sm:text-[10px] md:text-xs lg:text-sm xl:text-base 2xl:text-lg tracking-tight">
          {{ client.brandName }}
        </span>
      </div>
      <span class="text-dashboard-text font-black text-xs sm:text-sm md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-tight">
        {{ client.lbs }} LBS
      </span>
    </div>
    }
  </div>
</div>
